(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner-fade-in"] && !Shopify.designMode) return;
  try {
    
function gsapAnims(){

    if(gsap == undefined) return;

    gsap.to('.hero-banner__fade-out',  { ////// fade in canvas
        opacity: 0,
        y: '18vh',
        scale: '0.9',

        scrollTrigger: {
            trigger: "body", 
            start: "top top", 
            end: '15%',
            scrub: 0,
            immediateRender: false,
            //toggleActions: "play complete reverse reverse",
            onLeave: showLogo,
            onEnterBack: hideLogo,     
        }
    });
}
gsapAnims();

var bodyEle = document.getElementsByTagName('body')[0];

function showLogo(){
    bodyEle.classList.add('logo-display');
}
function hideLogo(){
    bodyEle.classList.remove('logo-display');
}


  } catch(e) { console.error(e); }
})();
})();
